import { FC, useEffect, useRef, useMemo } from 'react';
import { ChatMessage } from '../../types';
import { groupMessagesByDate } from '../../lib/helpers';
import { ChatMessageBubble } from '../ChatMessageBubble/ChatMessageBubble';
import { ChatDateSeparator } from '../ChatDateSeparator/ChatDateSeparator';

interface ChatMessageListProps {
  messages: ChatMessage[];
  currentUserId: number;
}

export const ChatMessageList: FC<ChatMessageListProps> = ({ messages, currentUserId }) => {
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages.length]);

  const groupedMessages = useMemo(() => groupMessagesByDate(messages), [messages]);

  return (
    <div className="flex-1 overflow-y-auto px-6 py-4">
      {groupedMessages.map((group) => (
        <div key={group.date}>
          <ChatDateSeparator date={group.date} />
          <div className="flex flex-col gap-3">
            {group.messages.map((message) => (
              <ChatMessageBubble
                key={message.id}
                message={message}
                isOwn={message.userId === currentUserId}
              />
            ))}
          </div>
        </div>
      ))}
      <div ref={bottomRef} />
    </div>
  );
};
